import React from 'react'

export const StoreContext = React.createContext([])

export const LayoutContext = React.createContext({})

export const DictionaryContext = React.createContext({})

export const ShopContext = React.createContext({})
